import gql from 'graphql-tag'

export default gql`
    mutation SubmitWithdrawal($input: WithdrawalInput!) {
        submitWithdrawal(input: $input) {
            status
            message
        }
    }
`
